import { Button } from "primereact/button";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const ActionNotAllowed = ({ menu, parent }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <div>
      <h1>
        <span>Action Not Allowed</span>
      </h1>
      <p>Sorry, you are not allowed to perform this action.</p>
      <Button
        outlined
        severity="secondary"
        icon="pi pi-arrow-left"
        label={intl.formatMessage({ id: "back" })}
        onClick={() => navigate(menu?.to || parent?.to)}
      />
    </div>
  );
};

export default ActionNotAllowed;
